import React from 'react';
import Link from 'next/link';
import styled from '@emotion/styled';
import { Grid, IconButton, Typography } from '@mui/material';
import Arrow from '../svgs/arrow.svg';
import Image from 'next/image';

export type SubpageBlobProps = {
  vector?: string;
  subpageName?: string;
  link?: string | '';
  width: string;
  justify?: string;
};

const MainDiv = styled(Grid)`
  height: auto;
  min-width: 235px;
  margin: 0;
  :hover {
    cursor: pointer;
  }
  @media (max-width: 768px) {
    width: 160px;
    min-width: 160px;
    height: auto;
    min-height: 228px;
    margin-bottom: 36px;
  }
`;
const VectorDiv = styled.div`
  height: 85%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  max-height: 198px;
  margin-bottom: 32px;
  @media (max-width: 768px) {
    align-items: flex-start;
    height: auto;
    margin-bottom: 22px;
    min-height: 135px;
  }
`;
const ArrowButton = styled(IconButton)`
  background: #f8d057;
  padding: 0;
  height: 34px;
  width: 34px;
  margin-left: 20px;
  @media (max-width: 768px) {
    margin-top: 0;
    margin-left: 10px;
  }
  :hover {
    background: #f1caba;
  }
`;

const LinkDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

const SubpageName = styled(Typography)`
  margin: 0;
  font-family: var(--font-work-sans), sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 137.8%;
  text-align: center;
  color: #ffffff;
`;

const StyledImage = styled(Image)`
  width: auto;
  height: auto;
`;
const SubpageBlob = ({
  vector,
  subpageName,
  link,
  justify,
}: SubpageBlobProps): React.ReactElement => {
  return (
    <Link href={`/about/${link}`} style={{ textDecoration: 'none' }}>
      <MainDiv item md={3} xs={6} sm={6}>
        <VectorDiv style={{ justifyContent: justify }}>
          <StyledImage src={vector!} alt={subpageName!} width={200} height={200} />
        </VectorDiv>
        <LinkDiv>
          <SubpageName>{subpageName}</SubpageName>
          <ArrowButton>
            <Arrow />
          </ArrowButton>
        </LinkDiv>
      </MainDiv>
    </Link>
  );
};

export default SubpageBlob;
